import { useParams } from "react-router-dom";
import invariant from "ts-invariant";

import { useGetLesson } from "api/services/content/hooks";
import { useProfileContext } from "contexts/ProfileContext";
import { PageContainer } from "routes/library/components";

import { LessonPreview } from "./components/LessonPreview";

export const Lesson: React.FC = () => {
  const { id } = useParams();
  const { profile } = useProfileContext();

  invariant(profile, "Profile should be defined");

  const lessonID = id ? parseInt(id, 10) : -1;
  const { data: lesson, isError, isLoading } = useGetLesson(lessonID);

  return (
    <PageContainer isError={isError} isLoading={isLoading}>
      {lesson && <LessonPreview lesson={lesson} isEditable={lesson.creator_id === profile.id} />}
    </PageContainer>
  );
};
